"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = void 0; // 目前只用到get，故只实现了get方法

exports.get = function (url, params, timeout) {
  return makeRequest('get', url, params, timeout).then(function (res) {
    try {
      return JSON.parse(res);
    } catch (e) {
      return res;
    }
  });
};

function makeRequest(method, url, params, timeout) {
  return new Promise(function (resolve, reject) {
    if (typeof params === 'number') {
      timeout = params;
      params = undefined;
    }

    if (method === 'get' && params && typeof params === 'object') {
      var paramsStr = Object.keys(params).map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      }).join('&');
      url = url + (url.indexOf('?') > -1 ? '' : '?') + paramsStr;
    }

    var xhr = new XMLHttpRequest();

    if (timeout && typeof timeout === 'number') {
      xhr.timeout = timeout;
    }

    xhr.open(method, url);

    xhr.onload = function () {
      if (this.status === 200) {
        resolve(xhr.response);
      } else {
        reject(xhr.response);
      }
    };

    xhr.onerror = function () {
      reject(xhr.response);
    };

    xhr.ontimeout = function () {
      reject();
    };

    xhr.send();
  });
}